import { getTadrisInfo, getTadrisDoreh, getDorehSchool } from "@/api/tadris";
export default {
    state: {
        tadrisInfo: {},
        tadrisDoreh: [],
        dorehSchool: [],
    },

    mutations: {
        SET_TADRIS_INFO: (state, data) => {
            state.tadrisInfo = data;
        },
        SET_TADRIS_DOREH: (state, data) => {
            state.tadrisDoreh = data;
        },
        SET_DOREH_SCHOOL: (state, data) => {
            state.dorehSchool = data;
        },
        // SET_MADRAK_HISTORY: (state, data) => {
        //   state.history = data
        // },
        // SET_LAST_KHOROOJ: (state, data) => {
        //   state.last = data
        // }
    },

    actions: {
        getTadrisInfo({ commit }) {
            return new Promise((resolve, reject) => {
                getTadrisInfo()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        var structure = [];
                        commit("SET_TADRIS_INFO", data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getTadrisDoreh({ commit }) {
            return new Promise((resolve, reject) => {
                getTadrisDoreh()
                    .then((response) => {
                        commit("SET_TADRIS_DOREH", []);
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_TADRIS_DOREH", data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getDorehSchool({ commit }, payload) {
            return new Promise((resolve, reject) => {
                getDorehSchool(payload)
                    .then((response) => {
                        commit("SET_DOREH_SCHOOL", []);
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_DOREH_SCHOOL", data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // getMadrakHistory({ commit }) {
        //   commit('SET_TABLE_TEXT', true)
        //   return new Promise((resolve, reject) => {
        //     getMadrakHistory().then(response => {

        //       if (!response.data) {
        //         reject('error')
        //       }
        //       const data = response.data
        //       ;
        //       commit('SET_MADRAK_HISTORY', data)
        //       commit('SET_TABLE_TEXT', false)

        //       resolve(response)

        //     }).catch(error => {
        //       reject(error)
        //     })
        //   })
        // },
    },
};